export default "__VITE_ASSET__c476f124__"